<svelte:options tag="gema-search" />

<script>
    import { afterUpdate, onMount } from 'svelte';

    import { Props, WebComponent, StoreAdapter } from "web-adapter-js";
    import { filter, map } from "rxjs/operators";
    const props = new Props();
    const webComponent = new WebComponent();
    const adapterChild = StoreAdapter.child;
    export let key = '';
    export let data = {
        title: '',
        placeholder: '',
        button: ''
    };
    const INTERVAL = 700;
    let type = null;
    let textInput = '';
    let address = [ ];

    const cpgs = [
        'https://images.rappi.com/web/pharmacy@2x.png?e=webp',
        'https://images.rappi.com/web/burguer@2x.png?e=webp',
        'https://images.rappi.com/web/fashion@2x.png?e=webp',
        'https://images.rappi.com/web/markets@2x.png?e=webp',
        'https://images.rappi.com/web/mrs@2x.png?e=webp',
        'https://images.rappi.com/web/sports@2x.png?e=webp',
    ];

    const autoComplete = (text) => {
        clearTimeout(type);
        type = setTimeout(async ()=> {
            adapterChild.dispatch({ autoComplete: text });
        }, INTERVAL);
    };

    const setAddress = (text) => {
        textInput = text;
        address = [];
    };

    const search = () => {
        if (isValidation()) {
            adapterChild.dispatch({ search: textInput })
        }
    };

    const browserType = (url) => {
        const isSafari = navigator.vendor.toLowerCase()
                .includes('apple');
        const [ serialize ] = url.split('?');
        return isSafari ? serialize : url;
    };

    const isValidation = () => (!!textInput && !!textInput.match(/[^ ](.*|\n|\r|\r\n)*/));

    afterUpdate(() => {
        const property = props.find(`gema-search-${key}`);
        if (!!key && property) {  data = property }
    });

    onMount(() => {
         adapterChild.on().pipe(
                filter(({ stateApp }) => !!stateApp['responseSearch']),
                map(({ stateApp: { responseSearch } }) => responseSearch ),
        ).subscribe( (responseSearch) => address = !!responseSearch ? responseSearch : []);
    });
</script>

<main>

    <header class="search">
        <div>
            { #each cpgs as img, i }
                <img src={browserType(img)} class={`space-img space-item-${i}`} alt="space" >
            {/each}
        </div>
        <div class="wrapperInput">
            <h1 class="title"> { data.title } </h1>

            <div class="currentInput">
                <div class="autocomplete">
                    <input type="text"
                           placeholder={data.placeholder}
                           on:input={ (e) => autoComplete(e.target.value) } bind:value={textInput}
                    >
                    {#if !!address.length}
                        <div class="address">
                            {#each address as item}
                                <div class="item" on:click={ (e) => setAddress(`${item.main_text} ${item.secondary_text}`) }>{item.main_text} {item.secondary_text}</div>
                            {/each}
                        </div>
                    {/if}
                </div>
                <button class={`btn-search ${ !!textInput.length ? '' : 'btn-disable' }`} on:click={search}>
                    { data.button }
                </button>
            </div>
        </div>
    </header>
</main>

<style type="text/scss">
    @import '../../../styles';
    @import '../../../scss/abstracts/mixins';
    main { max-width: 1440px; margin: 0 auto }

    @keyframes float {
        0% {
            transform: translatey(0px);
        }
        50% {
            transform: translatey(-20px);
        }
        100% {
            transform: translatey(0px);
        }
    }

    .btn-disable {
        background-image: initial !important;
        background-color: #e8e7e7;
    }
    .search {
        position: relative;
        height: 500px;
        display: flex;
        flex-direction: column;

        .wrapperInput {
            margin: 81px 0;
            z-index: 1;
            .title {
                text-align: center;
                @include font-poppins(40px, 600, normal, normal, normal,  normal, #332927);
            }
            .currentInput {
                display: flex;
                justify-content: center;

                .autocomplete {
                    width: 580px;
                    padding: 0 50px;

                    input {
                        width: 100%;
                        height: 60px;
                        border-radius: 15px;
                        background-color: #fff;
                        border: 1px solid #00000021;
                        padding: 0 15px;
                        font-size: 18px;
                        &:focus { outline: none; }
                    }

                    .address {
                        .item {
                            cursor: pointer;
                            background: #f8f8f8 url(https://home-guest.rappi.com/icons/location.svg) no-repeat scroll 23px;
                            height: 28px;
                            padding: 10px 60px;
                            border-bottom: 1px solid #e5edef;
                        }
                    }

                }

                .btn-search {
                    height: 60px;
                    font-size: 18px;
                    margin: 0;
                    background-image: linear-gradient(130deg,#ff9259 0,#ff2426 70%);
                    border-radius: 8px;
                    font-family: Poppins-Regular,Helvetica,Arial,sans-serif;
                    color: #fff;
                    padding: 0 60px;
                    text-align: center;
                    cursor: pointer;
                    border: 0;
                }
        }

    }

        .space-img {
            width: 100px;
            position: absolute;
            will-change: transform;
            transform: translatey(0px);
            animation: float 6s ease-in-out infinite;
        }

        .space-item-0 { top: 10px; left: 20%; }
        .space-item-1 { bottom: 200px; left: 5%; }
        .space-item-2 { left: 30%; bottom: 0; }
        .space-item-3 { bottom: 0; right: 30%; }
        .space-item-4 { right: 5%; bottom: 200px; }
        .space-item-5 { top: 10px; right: 20%; }

        @media (max-width: 750px) {
            .wrapperInput {
                .currentInput {
                    display: flex;
                    justify-content: center;
                    flex-direction: column;
                    position: relative;
                    .autocomplete {
                        width: inherit !important;
                        padding: inherit !important;

                        .address { width: 100%; position: absolute; }
                    }
                    .btn-search { margin-top: 15px }
                }
            }

            .space-img {  width: 80px; }

            .space-item-0 { top: 0; left: 25%; }
            .space-item-1 { bottom: inherit; left: 0; top: 45px; }
            .space-item-2 { display: none }
            .space-item-3 { display: none }
            .space-item-4 {  bottom: inherit; right: 0; top: 45px  }

        }
    }
</style>
